export default function isDevelopmentEnvironment() {
    const env = process.env.NODE_ENV;
    return !env || (env.indexOf('dev') > -1);
}
